import React, { Component } from 'react'
import { Form, Header } from 'semantic-ui-react'
import { inject, observer } from 'mobx-react'

@inject('surveyState')
@observer
export default class Note extends Component {
  onEnter = (e, { value = '' }) => this.props.onPartial(value)

  render() {
    const { mapped, surveyState } = this.props
    return (
      <div className={!mapped.partiallyAnswered ? 'disabled' : ''}>
        <Header as='h3'>
          <span style={{ fontWeight: 500 }}>
            {surveyState.renderTokens(mapped.notesText)}
          </span>
        </Header>
        <Form>
          <Form.TextArea
            name='value'
            placeholder={mapped.notesPlaceHolder}
            onChange={this.onEnter}
            defaultValue={mapped.noteAnswerValue}
          />
        </Form>
      </div>
    )
  }
}
